import React, { Component, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";
// const querystring = require("querystring");


const CreateContentCategoryType = () => {
  const [contentCategoryTypeCodes, setcontentCategoryTypeCodes] = useState([]);
//   const {token,userMetadata}=useAuth()
//   const history = useHistory();
	const token = globalConfig.hardcoded_header;
  const [message, setMessage] = useState("");
  const [state, setState] = useState({
    contentCategoryTypeId: 0,
    contentCategoryValueCode: 0,
    contentCategoryTypeName: "",
    contentCategoryTypeTitle: "",
    contentCategoryTypeDescr: "",
    contentCategoryTypeCdata: "",
    contentCategoryTypeBdata: "",
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
  });
  useEffect(() => {
    handleOnLoad();
  }, []);

  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value)
        ? target.value
        : target.value === ""
        ? ""
        : parseInt(target.value),
    });

    console.log(state);
  }

  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/content-category-types`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/content-category-types/contentCategoryTypeId`;
    console.log("request object = " + JSON.stringify(state));
    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentCategoryTypeId = response.data["nextId"];
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(
            response2.status + ":" + response2.data.contentCategoryTypeId
          );
          // && response2.data.contentCategoryTypeId === this.state.contentCategoryTypeId
          if (response2.status === 200) {
            setMessage("Success");
          } else {
            // console.log(response2.data.contentCategoryTypeId);
            // console.log(this.state.contentCategoryTypeId);
            // this.message = "Failed";
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
        })
        .catch((err) => {
          console.log("error - " + err);
        });

      console.log("message info - " + message);
      setState({
        ...state,
        contentCategoryTypeId: 0,
        contentCategoryValueCode: 0,
        contentCategoryTypeName: "",
        contentCategoryTypeTitle: "",
        contentCategoryTypeDescr: " ",
        contentCategoryTypeCdata: "",
        contentCategoryTypeBdata: "",
        lastUpdateUser: 0,
        lastUpdateDate: new Date().toISOString(),
      });
    });

    // console.log("SetState Message info-"+this.contentCategoryTypeTitle);
    // console.log("SetState Message info-"+this.contentCategoryTypeName);
    // console.log("SetState Message info-"+this.contentCategoryTypeDescr);
  }
  function handleRest(event) {
    setState({
      ...state,
      // contentCategoryTypeId : 0,
      contentCategoryTypeId: 0,
      contentCategoryTypeName: "",
      contentCategoryTypeDescr: " ",
      contentCategoryTypeTitle: "",
      contentCategoryTypeCdata: "",
    });
  }

  const handleOnLoad = () => {
    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_CATEGORY_TYPE`,
         apiHeader(token)
      )
      .then((res) => {
        const contentCategoryTypeCodes = res.data;
        console.log("results", contentCategoryTypeCodes);
        setcontentCategoryTypeCodes(contentCategoryTypeCodes);
      })
      .catch((err) => {
        console.log("here");
        console.log(err);
      });
  };

  return (
    <form>
		<div style={{display:"flex",justifyContent:"space-between"}}>
	        <h4>Create Content Category Type</h4>			
			<Link to="/breeze/list-content-category-types">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>

      <div className="container-fluid">

        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Category Type Name"
          >
            Content Category Type Name
          </label>
          <input
            id="contentCategoryTypeName"
            className="form-control input-xlarge col-sm-8"
            value={state.contentCategoryTypeName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Category Type Title"
          >
            Content Category Type Title
          </label>
          <input
            id="contentCategoryTypeTitle"
            className="form-control input-xlarge col-sm-8"
            value={state.contentCategoryTypeTitle}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Category Type Value Code"
          >
            Content Category Type Value Code
          </label>
          <select
            id="contentDescriptorTypeValue"
            onChange={handleChange}
            className="form-control input-xlarge col-sm-8"
            value={state.contentDescriptorTypeValue}
          >
            <option value={0}>Click to make selection </option>
            {contentCategoryTypeCodes.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeValueId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
          {/*
				<select id="contentCategoryTypeValueCode" className="form-control input-xlarge col-sm-8" value="#{ombContentCategoryTypeForm.createContentCategoryType.contentCategoryValueCode}">
				
					<option value={state.contentCategoryTypeValueCode} onChange={handleChange}/>
				</select>
				*/}
        </div>
        <div className="form-group row">
          <label
            className="ContentTitle col-sm-2"
            value="Content Category Type Description"
          >
            Content Category Type Description
          </label>
          <textarea
            id="contentCategoryTypeDescr"
            className="form-control input-xlarge col-sm-8"
            value={state.contentCategoryTypeDescr}
            onChange={handleChange}
          />

          {/* <textarea id="content_category_type_descr" className="form-control input-xlarge col-sm-8" value={state.contentCategoryTypeDescr} onChange={handleChange}/> */}
        </div>
        {/* <div className="form-group row">
				<label className="ContentTitle col-sm-2" value="Content Category Type CData">Content Category Type CData</label>
				<input id="contentCategoryTypeCdata" className="form-control input-xlarge col-sm-8" value={state.contentCategoryTypeCdata} onChange={handleChange} />
			</div>	 */}

        <hr />
        <div columns="3">
          <button
            className="btn btn-primary"
            value="Clear"
            type="reset"
            onClick={handleRest}
          >
            Clear
          </button>{" "}
          &nbsp;
          <button
            className="btn btn-success"
            value="Create"
            type="reset"
            onClick={handleSubmit}
          >
            Create
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreateContentCategoryType;



export class SelectListComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      entityName: "",
      keyColumnName: "",
      displayColumnName: "",
      valueFilter: "",
      entityObjects: [],
      valueId: "",
      optionItems: [],
    };
  }
  getData() {
    //var URL = 'http://os-dev.origosoftware.com:3000/'+this.props.entityName+'?filter[where]['+this.props.keyColumnName+']='+this.props.valueFilter
    //http://localhost:5100/code-catalog-data-service/get-data-list/system-code-values/systemCodeValueId/systemCodeValueValue/systemCodeId/234
    var URL =
      "http://os-dev.origosoftware.com:5100/code-catalog-data-service/get-data-list/" +
      this.props.entityName +
      "/" +
      this.props.keyColumnName +
      "/" +
      this.props.displayColumnName +
      "/" +
      this.props.valueFilterColumnName +
      "/" +
      this.props.valueFilter;
    console.log("URL: " + URL);
    var initialentityObjects = [];
    axios
      .get(URL)
      .then((response) => {
        console.log("Select:" + response.data);
        initialentityObjects = response.data;
        console.log(initialentityObjects.length);
        this.setState({ entityObjects: initialentityObjects });
      })
      .catch(function (error) {
        console.log("Error:" + error);
      });
  }
  componentDidMount() {
    this.getData();
  }
  componentDidUpdate() {
    console.log("componentDidUpdate");
    //this.getData();
  }

  render() {
    //this.getData();
    var i = 0;
    var tempMap = "";
    for (i = 0; i < 5; i++) {
      tempMap += '<option id="' + i + '">Value = ' + i + "</option>";
    }
    console.log("rendering - " + tempMap);

    return (
      <select
        className="form-control input-xlarge col-sm-8"
        value={this.state.contentDescriptorTypeValue}
      >
        <option id="0">Click to make a selection</option>
        {this.state.entityObjects.map(({ id, value }) => {
          return <option id={id}>{value}</option>;
        })}
      </select>
    );
  }
}